import React from 'react';
import { Link } from 'react-router-dom';
import { useSettings } from '../../context/SettingsContext';

const Footer = () => {
  const { settings } = useSettings();
  
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* معلومات الشركة */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center mb-4">
              <img 
                src="/footer-logo.png" 
                alt="أمازول" 
                className="h-16 w-auto"
              />
            </div>
            <p className="text-gray-300 mb-4">
              {settings.site_description}
            </p>
            <div className="flex space-x-4 space-x-reverse">
              {/* Facebook */}
              <a href={settings.social_facebook} target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors">
                <span className="sr-only">Facebook</span>
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              
              {/* Instagram */}
              <a href={settings.social_instagram} target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors">
                <span className="sr-only">Instagram</span>
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
              
              {/* X (Twitter) */}
              <a href={settings.social_twitter} target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors">
                <span className="sr-only">X (Twitter)</span>
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* روابط سريعة */}
          <div>
            <h3 className="text-lg font-semibold mb-4">روابط سريعة</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/products" className="text-gray-300 hover:text-white">
                  المنتجات
                </Link>
              </li>
              <li>
                <Link to="/vendors" className="text-gray-300 hover:text-white">
                  المتاجر
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-white">
                  من نحن
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-white">
                  اتصل بنا
                </Link>
              </li>
            </ul>
          </div>

          {/* للبائعين */}
          <div>
            <h3 className="text-lg font-semibold mb-4">للبائعين</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/vendor/register" className="text-gray-300 hover:text-white">
                  انضم كبائع
                </Link>
              </li>
              <li>
                <Link to="/vendor/dashboard" className="text-gray-300 hover:text-white">
                  لوحة البائع
                </Link>
              </li>
              <li>
                <Link to="/help/seller" className="text-gray-300 hover:text-white">
                  دليل البائع
                </Link>
              </li>
              <li>
                <Link to="/fees" className="text-gray-300 hover:text-white">
                  الرسوم والعمولات
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* معلومات إضافية */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <h4 className="font-semibold mb-2">معلومات الاتصال</h4>
              <p className="text-gray-300 text-sm">
                الخرطوم، السودان<br/>
                هاتف: +249 921003398<br/>
                البريد الإلكتروني: info@freedadel.com
              </p>
            </div>
            <div>
              <h4 className="font-semibold mb-2">طرق الدفع المقبولة</h4>
              <div className="flex space-x-2 space-x-reverse">
                <div className="bg-gray-700 px-2 py-1 rounded text-xs">
                  الدفع عند الاستلام
                </div>
                <div className="bg-gray-700 px-2 py-1 rounded text-xs">
                  تحويل بنكي
                </div>
                <div className="bg-gray-700 px-2 py-1 rounded text-xs">
                  محفظة إلكترونية
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* حقوق النشر */}
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-300 text-sm">
            © 2024 أمازول. جميع الحقوق محفوظة.
          </p>
          <div className="flex space-x-4 space-x-reverse mt-4 md:mt-0">
            <Link to="/privacy" className="text-gray-300 hover:text-white text-sm">
              سياسة الخصوصية
            </Link>
            <Link to="/terms" className="text-gray-300 hover:text-white text-sm">
              شروط الاستخدام
            </Link>
            <Link to="/help" className="text-gray-300 hover:text-white text-sm">
              المساعدة
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;